import styled from 'styled-components';
import { RadioGroup } from 'components/atoms/radio-buttons';
import { Table } from 'components/molecules/table';

export const Section = styled.div`
  padding: var(--layout-03) 0;

  & > * {
    margin-bottom: var(--layout-03);

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ContentBox = styled.div`
  width: 150px;
  color: var(--gray-70);
  text-align: right;
`;

export const SettingsLineWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
  margin-bottom: var(--spacing-05);
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
`;
export const Divider = styled.div`
  border-top: 1px solid var(--border-color);
  margin: var(--layout-01) 0;
`;

export const CheckBoxWrap = styled.div`
  color: var(--gray-80);
  display: flex;
  align-items: center;
  min-height: 32px;
  label {
    display: flex;
    align-items: center;
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const ReasonCodeWrapper = styled(Box)`
  flex-direction: column;
  align-items: stretch;
  margin-top: var(--layout-01);
`;

export const ReasonCodeTable = styled(Table)`
  .ant-table-tbody .ant-table-cell {
    padding-left: var(--spacing-05);
    padding-top: 1px;
    padding-bottom: 1px;
    height: 40px;
  }
`;
